import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { NavLink } from 'react-router-dom';
import { makeStyles, Typography } from './../../../../../assets/theme/default';

const useStyles = makeStyles(theme => ({
  root: {
    fontSize: theme.typography.body2.fontSize,
    lineHeight: 1,
    whiteSpace: 'nowrap'
  },
  link: {
    color: theme.palette.primary.main,
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline'
    }
  }
}));

const LinkMPPreference = ({ preference }) => {

  const classes  = useStyles();

  return (
    <Typography
      className={ classNames(
        classes.root,
        classes.link
      )}
      component={ NavLink }
      to={ `/api/mercadopago/checkout/detail/${ preference._id }` }
    >
      { preference.preference_code }
    </Typography>
  )

};

LinkMPPreference.propTypes = {
  preference: PropTypes.object.isRequired
};

export default LinkMPPreference;
